"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import $ from "jquery";
import _ from "underscore";
class ObjectWithIDStore {
  constructor(storeType, alwaysSendsNotifications) {
    __publicField(this, "items", []);
    __publicField(this, "index", {});
    __publicField(this, "type");
    __publicField(this, "notificationsEnabled", false);
    __publicField(this, "alwaysSendsNotifications");
    this.type = storeType || "unknown";
    this.alwaysSendsNotifications = !!alwaysSendsNotifications;
  }
  find(id) {
    return this.index[id];
  }
  findAll(ids) {
    return _.map(ids, this.find.bind(this));
  }
  addOrUpdate(item) {
    const existing = this.index[item.id];
    if (existing) {
      _.extend(existing, item);
      this.notifyOfChange(item);
      return existing;
    } else {
      this.items.push(item);
      this.index[item.id] = item;
      this.notifyOfChange(item);
      return item;
    }
  }
  destroy(item) {
    const existing = this.index[item.id];
    if (existing) {
      delete this.index[item.id];
      const idx = _.indexOf(this.items, item);
      if (idx !== -1) {
        this.items.splice(idx, 1);
      }
      this.notifyOfChange(item);
    }
    return item;
  }
  addOrUpdateAll(items) {
    return _.map(items, this.addOrUpdate.bind(this));
  }
  enableNotifications() {
    this.notificationsEnabled = true;
  }
  disableNotifications() {
    this.notificationsEnabled = false;
  }
  notifyOfChange(item) {
    if (this.alwaysSendsNotifications || this.notificationsEnabled) {
      $(this).trigger(storeItemChangedEvent(this.type, item.id), {
        item
      });
      $(this).trigger(storeChangedEvent(this.type), {});
    }
  }
}
export function storeItemChangedEvent(type, id) {
  return `storeItemChanged:${type}:${id}`;
}
export function storeChangedEvent(type) {
  return `storeChanged:${type}`;
}
export default ObjectWithIDStore;
